import * as React from 'react';

/**
 * Simplified upload icon optimized for small display sizes (16-24px).
 * Uses a 24×24 viewBox for consistent sizing with other tab icons.
 */
export function UploadIconSimple(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={20} height={20} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			{/* Cloud shape */}
			<path
				d='M18 10C19.5 10 21 11.5 21 13.5C21 15.5 19.5 17 18 17H7C4.5 17 3 15 3 13C3 11 4.5 9 7 9C7 9 7 9 7 9C7 5.5 9.5 3 13 3C16.5 3 19 5.5 19 9C19 9 19 9 19 9C18.5 9 18.5 9.5 18 10Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			{/* Upload arrow */}
			<path
				d='M12 21V12M12 12L9 15M12 12L15 15'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}
